import { getEventDesktop } from "app/api/eventsApi";
import Collapsible from "app/components/Collapsible/Collapsible";
import DangerZoneTextOnly from "app/components/DangerZoneTextOnly/DangerZoneTextOnly";
import {
  IconClock,
  IconFavorite,
  IconFavoriteAlt,
} from "app/components/Icon/Icon";
import { EventHelper } from "app/helpers/eventHelper";
import { MarketsHelper } from "app/helpers/marketsHelper";
import type { EventIncidentType, EventType } from "app/types/eventType";
import {
  DangerZoneStates,
  IncidentTypeStates,
  MarketPeriods,
  PollingIntervals,
  SportsNameType,
} from "app/utils/const";
import cx from "classnames";
import isEmpty from "lodash/isEmpty";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import VisibilitySensor from "react-visibility-sensor";
import {
  buildEventNavigationUrl,
  storeCurrentRouteAsPrevious,
} from "../../../../helpers/navigationUtils";
import "./PopularEventCellMobile.scss";
const MarketRow: React.LazyExoticComponent<any> = lazy(
  () => import("./components/MarketRow/MarketRow")
);
const EventCellStateDesktop: React.LazyExoticComponent<any> = lazy(
  () =>
    import(
      "../EventCell/components/EventCellStateDesktop/EventCellStateDesktop"
    )
);
//
type Props = {
  data: EventType;
  setEvent: (...args: Array<any>) => any;
  history: any;
  subscribeEvent: (...args: Array<any>) => any;
  unsubscribeEvent: (...args: Array<any>) => any;
  subscribeMarkets: (...args: Array<any>) => any;
  unsubscribeMarkets: (...args: Array<any>) => any;
  isIdle: boolean;
  resizeCell: (...args: Array<any>) => any;
  competitionIndex: number;
  betSlipList: any;
  favouritesOnly: boolean;
  addFavouriteToList: (...args: Array<any>) => any;
  removeFromFavouritesList: (...args: Array<any>) => any;
  setEventFavourite: (...args: Array<any>) => any;
};

const PopularEventCellMobile: React.FC<Props> = ({
  data,
  setEvent,
  isIdle,
  resizeCell,
  competitionIndex,
  betSlipList,
  favouritesOnly,
  addFavouriteToList,
  removeFromFavouritesList,
  setEventFavourite,
  subscribeEvent,
  unsubscribeEvent,
  subscribeMarkets,
  unsubscribeMarkets,
}) => {
  const [intervalId, setIntervalId] = useState<any>(0);
  const [intervalStarted, setIntervalStarted] = useState<boolean>(false);
  const [isFavourite, setIsFavourite] = useState<boolean>(data.favourite);
  const [isEventLoading, setIsEventLoading] = useState<boolean>(false);

  useEffect(() => {
    if (favouritesOnly && !isIdle) {
      fetchEventData(data.id);
    }
  }, []);

  useEffect(() => {
    if (data.isActive === undefined) {
      data.isActive = false;
    }
  }, [data]);

  useEffect(() => {
    return () => {
      const eventInBetslip = checkIfEventIsInBetslip(data.id);

      if (!eventInBetslip) {
        unsubscribeEvent(data.id);

        if (data.marketPeriods) {
          const marketIdList =
            data.marketPeriods &&
            !isEmpty(data.marketPeriods) &&
            data.marketPeriods[0].marketTypes.map(
              marketType => marketType.markets[0].id
            );
          marketIdList && unsubscribeMarkets(marketIdList);
        }
      }

      endIntervalFetchEvent();
      setIsEventLoading(false);
    };
  }, []);

  const toggleCollapsible = () => {
    if (data.isActive !== undefined) {
      data.isActive = !data.isActive;
    } else {
      data.isActive = false;
    }

    setIsEventLoading(true);
    setEvent(data);
    fetchEventData(data.id);
  };

  const checkIfEventIsInBetslip = (eventId: number) => {
    let eventInBetslip = false;
    betSlipList.length > 0 &&
      betSlipList.forEach(betSlip => {
        if (betSlip.id === eventId) {
          eventInBetslip = true;
        } else {
          eventInBetslip = false;
        }
      });
    return eventInBetslip;
  };

  const onEventVisible = (
    isVisible: boolean,
    eventId: number,
    eventIsActive: boolean,
    marketTypes: Record<string, any>
  ) => {
    const marketIdList = marketTypes.map(marketType => {
      return marketType.markets[0].id;
    });
    const eventInBetslip = checkIfEventIsInBetslip(eventId);

    if (isVisible) {
      subscribeEvent(eventId);
      startIntervalFetchEvent();
    } else {
      if (!eventInBetslip) {
        unsubscribeEvent(eventId);
        endIntervalFetchEvent();
      }
    }

    if (isVisible && marketIdList.length > 0) {
      subscribeMarkets(marketIdList);
    } else {
      if (!eventInBetslip) {
        unsubscribeMarkets(marketIdList);
      }
    }
  };

  const startIntervalFetchEvent = () => {
    if (!intervalStarted) {
      const interval = setInterval(() => {
        if (isIdle) return;
        // issue where this is called each time isVisible = true
        // resulting in numerous calls being made at once
        // fetchEventData(data.id);
      }, PollingIntervals.MOBILE_EVENT);
      setIntervalId(interval);
      setIntervalStarted(true);
    }
  };

  const endIntervalFetchEvent = () => {
    clearInterval(intervalId);
    setIntervalStarted(false);
  };

  const fetchEventData = (id: number) => {
    getEventDesktop(
      id,
      true,
      true,
      null,
      null,
      null,
      data.isActive,
      data.sportType
    )
      .then(eventData => {
        setEvent(eventData);
        resizeCell(competitionIndex);

        if (isEventLoading) {
          setIsEventLoading(false);
        }
      })
      .catch(error => {
        throw error;
      });
  };

  const toggleAddRemoveToFavorites = (eventId: number) => {
    // let favouritesOnly = favouritesOnly;

    if (!isFavourite) {
      addFavouriteToList(eventId);
      updateFavourite(eventId, favouritesOnly);
    } else {
      removeFromFavouritesList(eventId);
      updateFavourite(eventId, favouritesOnly);
    }
  };

  const updateFavourite = (eventId: number, favouritesOnly: boolean) => {
    setIsFavourite(!isFavourite);
    getEventDesktop(
      eventId,
      true,
      true,
      null,
      null,
      null,
      data.isActive,
      data.sportType
    )
      .then(eventData => {
        setEventFavourite(eventData, favouritesOnly);
      })
      .catch(error => {
        throw error;
      });
  };

  const displayFullTimeScoreInExtraTimeScores = (
    eventIncidents: EventIncidentType[],
    period: string
  ) => {
    const homeScoreFullTime = EventHelper.getHomeScore(
      eventIncidents[0]["scoreDetails"]
    );
    const awayScoreFullTime = EventHelper.getAwayScore(
      eventIncidents[0]["scoreDetails"]
    );
    const scoreFullTime = (
      <span className="extra-time-ft-score">
        FT&nbsp;({homeScoreFullTime} - {awayScoreFullTime})
      </span>
    );
    return scoreFullTime;
  };

  const yellowCards = {
    home: 0,
    away: 0,
  };
  const redCards = {
    home: 0,
    away: 0,
  };
  const corners = {
    home: 0,
    away: 0,
  };
  let eventStat: any = null;

  if (data.eventIncidents != null) {
    eventStat = data.eventIncidents[0];

    if (eventStat["eventPhase"].includes(MarketPeriods.EXTRA_TIME)) {
      eventStat["currentPeriodScoreDetails"].forEach(currentScore => {
        switch (currentScore.type) {
          case IncidentTypeStates.HOME_YELLOW_CARD:
            yellowCards.home += currentScore.score;
            break;

          case IncidentTypeStates.AWAY_YELLOW_CARD:
            yellowCards.away += currentScore.score;
            break;

          case IncidentTypeStates.HOME_RED_CARD:
            redCards.home += currentScore.score;
            break;

          case IncidentTypeStates.AWAY_RED_CARD:
            redCards.away += currentScore.score;
            break;

          case IncidentTypeStates.HOME_CORNER:
            corners.home += currentScore.score;
            break;

          case IncidentTypeStates.AWAY_CORNER:
            corners.away += currentScore.score;
            break;

          default:
            return null;
        }
      });
    } else {
      eventStat["scoreDetails"].forEach(currentScore => {
        switch (currentScore.type) {
          case IncidentTypeStates.HOME_YELLOW_CARD:
            yellowCards.home += currentScore.score;
            break;

          case IncidentTypeStates.AWAY_YELLOW_CARD:
            yellowCards.away += currentScore.score;
            break;

          case IncidentTypeStates.HOME_RED_CARD:
            redCards.home += currentScore.score;
            break;

          case IncidentTypeStates.AWAY_RED_CARD:
            redCards.away += currentScore.score;
            break;

          case IncidentTypeStates.HOME_CORNER:
            corners.home += currentScore.score;
            break;

          case IncidentTypeStates.AWAY_CORNER:
            corners.away += currentScore.score;
            break;

          default:
            return null;
        }
      });
    }
  }

  const scoreFullTime =
    data.eventIncidents &&
    displayFullTimeScoreInExtraTimeScores(data.eventIncidents, "fullTime");
  const { isHome, isAway, possibleVar, incidentType, dangerZoneState } =
    EventHelper.formatIncidentText(
      data.eventIncidents && data.eventIncidents[0]
    );
  const showDangerText =
    data.eventIncidents != null &&
    (incidentType != null ||
      possibleVar ||
      dangerZoneState !== DangerZoneStates.SAFE ||
      dangerZoneState !== DangerZoneStates.MISSED_INCIDENT);
  const isOutright = MarketsHelper.isOutright(null, data.sportType);
  const markets = isOutright
    ? data.alternativeMarketPeriods || []
    : data.marketPeriods || [];
  const isCricketEvent = React.useMemo(
    () => data.sportType === SportsNameType.CRICKET,
    [data.sportType]
  );
  const isEventLive = React.useMemo(
    () => EventHelper.isEventLive(data),
    [data.allowLiveBetting, data.inRunning]
  );

  return (
    <VisibilitySensor
      onChange={isVisible =>
        onEventVisible(
          isVisible,
          data.id,
          data.isActive,
          markets.length > 0 ? markets[0].marketTypes : markets
        )
      }
      delayedCall={true}
    >
      <Collapsible
        status={data.status.toLowerCase()}
        suspended={<div className="suspended__text--event">{data.status}</div>}
        header={
          <div
            className={cx(`popular-event-cell`, {
              "popular-event-cell--no-odds":
                !isEventLoading && markets.length === 0,
            })}
            id={data.id}
          >
            <Suspense fallback={<div className="fallback">loading...</div>}>
              {isCricketEvent && isEventLive ? (
                <div className="popular-event-cell-state popular-event-cell-state--live-phase">
                  <FormattedMessage tagName="span" id="events-dashboard-live" />
                </div>
              ) : (
                <EventCellStateDesktop data={data} />
              )}
            </Suspense>
            <div className="popular-event-cell__label">
              <div className="popular-event-cell__label__top">
                <div>
                  {EventHelper.isEventGoingLive(data) && (
                    <IconClock className="icon-desktop--inactive popular-event-cell__event-clock-icon" />
                  )}
                  <span onClick={() => toggleAddRemoveToFavorites(data.id)}>
                    {isFavourite && (
                      <IconFavoriteAlt
                        className={`icon--${
                          data.favourite ? "active" : "inactive"
                        }`}
                      />
                    )}
                  </span>
                  {isOutright ? "" : isHome || isAway ? scoreFullTime : ""}
                </div>
              </div>
              <div className="popular-event-cell__label__bottom">
                <div className="teams">
                  {isOutright ? (
                    <div>{data.competition.name}</div>
                  ) : (
                    <>
                      <div className={`team-1 ${isHome ? "is-home" : ""}`}>
                        <div className="popular-event-cell__label__bottom_team">
                          <span>{data.participant1}</span>
                        </div>
                        {showDangerText && isHome && (
                          <DangerZoneTextOnly
                            eventIncident={data.eventIncidents[0]}
                            className={data.isActive ? "active" : ""}
                            incidentType={incidentType}
                            dangerZoneState={dangerZoneState}
                            possibleVar={possibleVar}
                            isAway={isAway}
                            isHome={isHome}
                          />
                        )}
                      </div>
                      <div className={`team-2 ${isAway ? "is-away" : ""}`}>
                        <div className="popular-event-cell__label__bottom_team">
                          <span>{data.participant2}</span>
                        </div>
                        {showDangerText && isAway && (
                          <DangerZoneTextOnly
                            eventIncident={data.eventIncidents[0]}
                            className={data.isActive ? "active" : ""}
                            incidentType={incidentType}
                            dangerZoneState={dangerZoneState}
                            possibleVar={possibleVar}
                            isAway={isAway}
                            isHome={isHome}
                          />
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
            {data.numberOfMarkets > 0 ? (
              <Link
                className="popular-event-cell__markets-total"
                key={0}
                to={buildEventNavigationUrl(data.id, data.name)}
                style={{
                  textDecoration: "none",
                }}
                onClick={() => storeCurrentRouteAsPrevious()}
              >
                <span className="divider" />
                <span className="popular-event-cell__markets-total__button">
                  +{data.numberOfMarkets}
                </span>
              </Link>
            ) : (
              <div className="no-odds-available">
                <FormattedMessage tagName="span" id="events-no-odds" />
              </div>
            )}
          </div>
        }
        content={
          data.isActive && (
            <>
              {markets.length > 0 &&
                markets[0].marketTypes.map((market, index) => (
                  <Suspense
                    key={"key-" + index}
                    fallback={<div className="fallback">loading...</div>}
                  >
                    <MarketRow
                      status={data.status}
                      event={data}
                      market={market}
                      showHomePlayerAsFirst={data.showHomePlayerAsFirst}
                      key={index}
                    />
                  </Suspense>
                ))}
              <div className="popular-event-cell__buttons">
                <div className="popular-event-cell__buttons__col">
                  <button
                    className="popular-event-cell__buttons__button"
                    onClick={() => toggleAddRemoveToFavorites(data.id)}
                  >
                    {data.favourite ? (
                      <>
                        <IconFavorite
                          className="popular-event__favourite-active"
                          currentColor
                        />
                        <FormattedMessage
                          tagName="span"
                          id="events-remove-from-favorites"
                        />
                      </>
                    ) : (
                      <>
                        <IconFavorite currentColor />
                        <FormattedMessage
                          tagName="span"
                          id="events-add-to-favorites"
                        />
                      </>
                    )}
                  </button>
                </div>
              </div>
            </>
          )
        }
        isActive={data.isActive}
        onToggle={toggleCollapsible}
      />
    </VisibilitySensor>
  );
};

const mapStateToProps = state => ({
  isIdle: state.sessionModel.isIdle,
  betSlipList: state.betSlipListModel.betSlipList,
  currentFavouritesCount: state.favouritesListModel.currentFavouritesCount,
  favouritesOnly: state.competitionListModel.favouritesOnly,
});

const mapDispatchToProps = dispatch => {
  return {
    setEvent: (event: EventType) =>
      dispatch.competitionListModel.updateEventInCompetitionInList(event),
    setEventFavourite: (event: EventType, favouritesOnly: boolean) =>
      dispatch.competitionListModel.updateEventFavouriteInCompetitionInList(
        event,
        favouritesOnly
      ),
    subscribeEvent: (eventId: number) =>
      dispatch.subscribeModel.subscribeEvent({
        eventId,
      }),
    unsubscribeEvent: (eventId: number) =>
      dispatch.subscribeModel.unsubscribeEvent({
        eventId,
      }),
    subscribeMarkets: (marketIdList: number[]) =>
      dispatch.subscribeModel.subscribeMarkets({
        marketIdList,
      }),
    unsubscribeMarkets: (marketIdList: number[]) =>
      dispatch.subscribeModel.unsubscribeMarkets({
        marketIdList,
      }),
    addFavouriteToList: (eventId, callback) =>
      dispatch.favouritesListModel.addFavouriteToList({
        eventId,
        callback,
      }),
    removeFromFavouritesList: (eventId, callback) =>
      dispatch.favouritesListModel.removeFromFavouriteToList({
        eventId,
        callback,
      }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PopularEventCellMobile);
